import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import AssetFinanceAssetCommitment from './AssetFinanceAssetCommitment';
import type { IAssetFinanceAssetCommitmentSchedule } from './AssetFinanceAssetCommitmentSchedule.interface';

export default class AssetFinanceAssetCommitmentSchedule
  implements IAssetFinanceAssetCommitmentSchedule {
  id: string;
  idContact: string;
  assetCommitments: Array<AssetFinanceAssetCommitment>;

  static build = (data: IAssetFinanceAssetCommitmentSchedule) =>
    new AssetFinanceAssetCommitmentSchedule(data);

  static blank = () => new AssetFinanceAssetCommitmentSchedule();

  constructor(data?: IAssetFinanceAssetCommitmentSchedule) {
    this.id = toUUID(data?.id) || uuid();
    this.idContact = toUUID(data?.idContact);
    this.assetCommitments = compact(
      map(data?.assetCommitments, (obj) => new AssetFinanceAssetCommitment(obj))
    );
  }
}
